module.exports = __webpack_public_path__ + "static/media/homepage-banner-lost-wallet-icon.95237aa5.svg";